import React from 'react'
import styles from './YearChange.module.css'

import FontAwesome from 'react-fontawesome'
import '../layouts/fontawesome/font-awesome-4.7.0/css/font-awesome.css'

import YearDefinitions from '../data/YearDefinitions'

export default ({ suffix, setYearSuffix }) => {
  const selectedYearIndex = YearDefinitions.findIndex(d => d.suffix === suffix)
  const selectedYear = YearDefinitions[selectedYearIndex]
  const previousYear = YearDefinitions[selectedYearIndex + 1] || null
  const nextYear = YearDefinitions[selectedYearIndex - 1] || null

  return (
    <div className={styles.year}>
      {previousYear ? (
        <div
          className={styles.arrow}
          onClick={() => setYearSuffix(previousYear.suffix)}
        >
          <FontAwesome name="angle-double-left" />
        </div>
      ) : (
        <div className={styles.arrowInactive}>
          <FontAwesome name="angle-double-left" />
        </div>
      )}
      <div className={styles.text}>{selectedYear.label}</div>
      {nextYear ? (
        <div
          className={styles.arrow}
          onClick={() => setYearSuffix(nextYear.suffix)}
        >
          <FontAwesome name="angle-double-right" />
        </div>
      ) : (
        <div className={styles.arrowInactive}>
          <FontAwesome name="angle-double-right" />
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/YearChange.js